import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MoonIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-32 px-4 bg-navy-900 relative overflow-hidden" data-id="element-131">
      {/* Subtle background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-132" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-133">
        <FadeIn data-id="element-134">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 text-gold mb-8" data-id="element-135">
            <MoonIcon className="w-8 h-8" data-id="element-136" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-137">
          <h2 className="text-sm tracking-[0.2em] uppercase text-muted font-sans font-semibold mb-4" data-id="element-138">
            El Mecanismo Único
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold text-cream mb-10" data-id="element-139">
            Presentamos la <br data-id="element-140" />
            <span className="text-transparent bg-clip-text bg-gold-gradient" data-id="element-141">
              Sincronía Daycare
            </span>
          </h3>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-142">
          <p className="text-xl md:text-2xl text-muted leading-relaxed font-light" data-id="element-143">
            A diferencia de otros métodos, este sistema alinea biológicamente el
            sueño de tu hogar con los estándares de los centros de cuidado en
            USA. Al crear una estructura predecible las 24 horas, el cerebro del
            bebé finalmente entiende cuándo es momento de{' '}
            <span className="text-cream font-medium" data-id="element-144">
              "apagarse" profundamente
            </span>
            .
          </p>
        </FadeIn>
      </div>
    </section>;
}